import {requestCheckBriefEmailCondition} from "@pages/dvtjcuv/service/DVTJCUVService";
import {ResponseCode} from "@app/constants/Common";
import {alertMessage, showMessage} from "@app/constants/Messages";
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";

export const processRequestCheckDVTJCUVEmailBrief = async (condition) => {
    const res = await requestCheckBriefEmailCondition(condition)
    if (res.sts_code === ResponseCode.SUCCESS) {
        const inviteResult = res.content.email_tab
        const notPermissionCandidateIds = inviteResult.not_permission_email_candidate_ids
        const needCheckingCandidateIds = inviteResult.need_checking_candidate_ids
        const needInputInfoCandidateIds = inviteResult.need_input_info_candidate_ids
        const approveDraftCandidateIds = inviteResult.approve_draft_candidate_ids
        const sendByWeekCandidateIds = inviteResult.send_by_week_candidate_ids
        const sendByMonthCandidateIds = inviteResult.send_by_month_candidate_ids
        let tabNo = 2;
        if (condition.invite_mode === EmailInviteMode.INVITE_EMAIL_DN_UPDATE_INFO) {
            tabNo = 5.2;
        }
        else if (condition.invite_mode === EmailInviteMode.INVITE_EMAIL_FU_REC) {
            tabNo = 3.2;
        }
        let resultChecks = `
                    Kết quả check:
                    Số Receiver tab ${tabNo}.1: ${approveDraftCandidateIds.length}
                    Số Receiver tab ${tabNo}.2: ${notPermissionCandidateIds.length}
                    Số Receiver tab ${tabNo}.3: ${needCheckingCandidateIds.length}
                    Số Receiver tab ${tabNo}.4: ${needInputInfoCandidateIds.length}`
        if (condition.invite_mode === EmailInviteMode.INVITE_BRIEF_EMAIL) {
            resultChecks += `
            Số Receiver tab ${tabNo}.5: ${sendByWeekCandidateIds.length}
            Số Receiver tab ${tabNo}.6: ${sendByMonthCandidateIds.length}`
        }

        showMessage(resultChecks)
        return true;
    }

    alertMessage(res.sts_code, true, false);
    return false;
}